import { ngCellEx } from "./_ngCell.js";

class ngButton extends ngCellEx
{
	#target;
	
	constructor () {
		super();
		this.applyBaseStyle();
	}
	
	connectedCallback() {

		var attr = [];
		for (var i = 0; i < this.attributes.length; i++) {
			if (["color","background","border"].includes(this.attributes[i].name)) attr.push(`${this.attributes[i].name}="${this.attributes[i].value}"`);
		}

		this.shadowRoot.innerHTML =`
			<button class="button" ${attr.join(" ")}>${this.getAttribute("text")}</button>
		`;
		
		super.connectedCallback();
		
		this.#target = this.shadowRoot.querySelector("button");
		
		$(this.cell).on("keydown", e => { if (e.code == "Enter") $(this.#target).trigger("click"); });
	};
	
	dataRefresh = (v) => {
		this.#target.innerHTML = this.getDisplayText(this.getAttribute("text"));
		
		var row = parseInt(this.cell.dataset.row);
		const data = this.cell.closest("tr").data;
		
		["color","background","border"].forEach(v => {
			var expr = this.#target.getAttribute(v);
			if (expr) {
				$(this.#target).css({
					[v] : this.getExprValue(expr, data, row),
				});
			}
		});
		
		if (!v) this.reset();
	};
}
if (!customElements.get('ng-button')) {
	customElements.define("ng-button", ngButton);
}
